import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import SponsorManager from './assets/pages/SponsorManager';
import MainLayout from './assets/pages/mainLayout';
import UserLicence from './assets/pages/userLicence';
import AddNews from './assets/pages/AddNews';
import NewsList from './assets/pages/NewsList';
import NoticiaDetalhada from './assets/pages/Article';
import AdminLogin from './assets/pages/AdminLogin';
import ProtectedRoute from './assets/components/ProtectedRoute';


const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: '/userLicence',
        element: <UserLicence />
      },
      {
        path: '/news-list',
        element: <NewsList />
      },
      {
        path: '/article/:id',
        element: <NoticiaDetalhada />
      },
      
      {
        path: '/admin/login',
        element: <AdminLogin />
      },

      {
        path: '/SponsorManager',
        element: <ProtectedRoute><SponsorManager /></ProtectedRoute>
      },
      {
        path: '/add-news',
        element: <ProtectedRoute><AddNews /></ProtectedRoute>
      },
      {
        path: '/edit-news/:id',
        element: <ProtectedRoute><AddNews /></ProtectedRoute>,
        errorElement: <div>Erro ao carregar página de edição</div>
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);

